import { useTranslation } from 'react-i18next';
import React, { useState, useEffect } from 'react'
import { useSaleRoModel } from "../saleRoModel";
import { YhOfferPrint } from "@/erp_subpackage/components/YhOfferPrint/offerPrint"
import { saleRoService } from '../saleRoService';
import { numberParseChina, fmoney, momentFormat } from '@/erp_subpackage/utils/util';
import { useDictModel } from '@/erp_subpackage/pages/base/dict/dictModel';
import moment from 'moment';
import useGlobalModel from '@/erp_subpackage/model/globalModel';

export function SalePrint() {
    const { t } = useTranslation();
    const initDesc = { total: 0, discount: 0 }
    const totalDesc = { total: 0, num: 0 }
    const { user: { shopName, shopId, shopCode } } = useGlobalModel()
    const [settlementPartyName, setSettlementPartyName] = useState("")
    const {
        print: visible,
        selectedRow,
        setPrint,
        loadData
    } = useSaleRoModel();
    const [formVal, setFormVal] = useState({});
    const [maintenanceList, setMaintenanceList] = useState([]);
    const [maintenanceTotal, setMaintenanceTotal] = useState(initDesc);
    const [itemTotal, setItemTotal] = useState(initDesc);
    const [total, setTotal] = useState(totalDesc);
    const { getTreeNodeName, getTreeNodeOne } = useDictModel();
    useEffect(() => {
        visible && getPoDetailOne()
    }, [visible])
    //获取一条数据
    const getPoDetailOne = async () => {
        let { retData } = await saleRoService.one(selectedRow.returnCode);
        let { details, settlementPartyCode, customerName, ...formVal } = retData;
        let newMaintenanceTotal = { ...maintenanceTotal }
        let newItemTotal = { ...itemTotal }
        let newTotal = { ...total }
        let newdetails = details?.sort((a, b) => a.materialCode?.localeCompare(b.materialCode, 'zh-Hans-CN', { sensitivity: 'accent' })).sort((a, b) => a.shelfCode?.localeCompare(b.shelfCode, 'zh-Hans-CN', { sensitivity: 'accent' })).map((item, index) => {
            newMaintenanceTotal.total += Number(item.num) * Number(item.price)
            newTotal.num += Number(item.num)
            let { amount } = item
            return {
                ...item,
                No: index + 1,
                price: fmoney(item.price, 2),
                notAmount: Number(item.num) * Number(item.price),
                amount: fmoney(amount, 2)
            }
        })
        // if (settlementPartyCode === "settle-party.internal") {
        //     setSettlementPartyName(shopName)
        // } else if (settlementPartyCode && (settlementPartyCode?.indexOf("man") !== -1 || settlementPartyCode?.indexOf("scn") !== -1)) {
        //     let { value: customerCode } = getTreeNodeOne(settlementPartyCode)[0]
        //     setSettlementPartyName(getFindItem(customerCode, CustomerData).name)
        // } else {
        //     setSettlementPartyName(customerName )
        // }
        if (retData) {
            setMaintenanceList(newdetails ?? []);
            setFormVal({ ...formVal, settlementPartyCode, customerName })
            setMaintenanceTotal(newMaintenanceTotal)
            setItemTotal(newItemTotal)
        }
    };
    const printNum = async () => {
        await saleRoService.printNum(selectedRow.id);
        await loadData()
    }
    const onCancel = () => {
        setPrint(false)
        setMaintenanceList([]);
        setFormVal({})
        setMaintenanceTotal(initDesc)
        setItemTotal(initDesc)
    }
    const columns = [
        {
            title: t(`sale.view.SalePrint.序号`),
            dataIndex: 'No',
        },
        {
            title: t(`sale.view.SalePrint.商品编号`),
            dataIndex: 'materialCode',
        },
        {
            title: t(`sale.view.SalePrint.商品名称`),
            dataIndex: 'materialName',
        },
        {
            title: t(`sale.view.SalePrint.单位`),
            dataIndex: 'unitName',
        },
        {
            title: t(`sale.view.SalePrint.数量`),
            dataIndex: 'num',
        },
        {
            title: t(`sale.view.SalePrint.单价`),
            dataIndex: 'price',
        },
        {
            title: t(`sale.view.SalePrint.金额`),
            dataIndex: 'amount',
        },
        {
            title: t(`sale.view.SalePrint.仓库`),
            dataIndex: 'warehouseName',
        },
        {
            title: t(`sale.view.SalePrint.货位`),
            dataIndex: 'shelfCode',
        },
        {
            title: t(`sale.view.SalePrint.销售单号`),
            dataIndex: 'saleCode',
        }
    ]
    const XJHeader = [
        {
            fieldLabel: `${t(`sale.view.SalePrint.车牌号`)}：`,
            fieldValue: formVal?.licensePlate
        },
        {
            fieldLabel: `${t(`sale.view.SalePrint.底盘号`)}：`,
            fieldValue: formVal?.vin
        },
        {
            fieldLabel: `${t(`sale.view.SalePrint.结算方式`)}：`,
            fieldValue: getTreeNodeName(formVal.payType)
        },
        {
            fieldLabel: `${t(`sale.view.SalePrint.结算方`)}：`,
            className: "li-right",
            fieldValue: settlementPartyName,
        },
    ]
    //头部与底部展示
    const printShow = {
        header: [
            {
                fieldLabel: `${t(`sale.view.SalePrint.销退单号`)}: `,
                fieldValue: formVal?.returnCode,
                className: "w30"
            },
            {
                fieldLabel: `${t(`sale.view.SalePrint.客户名称`)}: `,
                fieldValue: formVal?.customerName,
            },
            {
                fieldLabel: `${t(`sale.view.SalePrint.打印日期`)}: `,
                fieldValue: moment(new Date()).format("YYYY-MM-DD HH:mm"),
                //className: "li-right"
            },
            {
                fieldLabel: `${t(`sale.view.SalePrint.销售单号`)}: `,
                fieldValue: maintenanceList?.[0]?.saleCode ?? '',
                className: "w30"
            },
            {
                fieldLabel: `${t(`sale.view.SalePrint.联系人`)}：`,
                fieldValue: formVal?.contact
            },
            {
                fieldLabel: `${t(`sale.view.SalePrint.销售日期`)}：`,
                fieldValue: momentFormat(formVal?.createTime),
                className: "li-right"
            },
            {
                fieldLabel: `${t(`sale.view.SalePrint.单据性质`)}：`,
                fieldValue: t(`sale.view.SalePrint.销售退货单`),
                className: "w30"
            },
            {
                fieldLabel: `${t(`sale.view.SalePrint.电话`)}：`,
                fieldValue: formVal?.phone
            },
            {
                fieldLabel: "",
                fieldValue: "",
                className: "li-right"
            },


        ],
        footerPeople: [
            {
                fieldLabel: `${t(`sale.view.SalePrint.制表人`)}：`,
                fieldValue: formVal?.createUser
            },
            {
                // fieldLabel: "销售}：`,
                fieldLabel: "",
                fieldValue: ""
            },
            {
                // fieldLabel: "出纳}：`,
                fieldLabel: "",
                fieldValue: ""
            },
            // {
            //     fieldLabel: "仓库}：`,
            //     fieldValue: maintenanceList[0]?.warehouseName
            // },
            {
                fieldLabel: `${t(`sale.view.SalePrint.客户签字`)}：`,
                fieldValue: ""
            },
            // {
            //     fieldLabel: "会计}：`,
            //     fieldValue: ""
            // },

        ],
        note: {
            fieldLabel: `${t(`sale.view.SalePrint.备注`)}: `,
            fieldValue: formVal?.note
        },
        Total: {

            numAll: maintenanceList.length,
            receivedAmountChina: numberParseChina(formVal?.receivedAmount),
            receivedAmount: fmoney(formVal?.receivedAmount, 2),
            label: t(`sale.view.SalePrint.应付金额`)
        },
    }
    const headerTitle = {
        // title: "天津欧豪富港汽车贸易有限公司销售退货单"
        title: `${formVal.bentityName}${t(`sale.view.SalePrint.销售退货单`)}`

    }
    return (
        <YhOfferPrint
            title={t(`sale.view.SalePrint.销售退货单打印详情`)}
            type=""
            visible={visible}
            onClose={onCancel}
            printNum={printNum}
            columns={columns}
            dataSource={maintenanceList.filter(item => item.num !== 0)}
            printShow={printShow}
            headerTitle={headerTitle}
        />
    )
}